import { render, staticRenderFns } from "./DispensationDetailsMessages.vue?vue&type=template&id=2fe3cafc&scoped=true&"
import script from "./DispensationDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./DispensationDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3cafc",
  null
  
)

export default component.exports